"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSTCODE_UK = exports.POSTCODE_IE = exports.POSTCODE_DATA_STANDARDS = exports.POSTCODE = void 0;
var _react = _interopRequireDefault(require("react"));
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _InputWithSubmit = _interopRequireDefault(require("../../elements/input-with-submit/InputWithSubmit"));
var _restrictInput = require("../normalizers/restrictInput");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var POSTCODE = exports.POSTCODE = {
  component: _Input["default"],
  type: 'text',
  name: 'postcode',
  id: 'postcode',
  label: 'Postcode',
  className: 'addressPostcodeField',
  required: true,
  validationMessageKeys: {
    required: 'Please enter a postcode',
    regex: 'Please enter a valid postcode for ${country}'
  },
  normalize: _restrictInput.uppercaseLettersNumbersSpacesDash,
  autoComplete: 'postal-code'
};
var POSTCODE_UK = exports.POSTCODE_UK = _objectSpread(_objectSpread({}, POSTCODE), {}, {
  normalize: _restrictInput.uppercaseLettersNumbersSpaces
});
var POSTCODE_IE = exports.POSTCODE_IE = _objectSpread(_objectSpread({}, POSTCODE), {}, {
  label: 'Eircode',
  required: false,
  validationMessageKeys: {
    regex: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: ["Please enter a valid Eircode. Find your Eircode", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: "https://finder.eircode.ie/",
        target: "_blank",
        rel: "noopener noreferrer",
        children: "here"
      }), "."]
    })
  }
});
var POSTCODE_DATA_STANDARDS = exports.POSTCODE_DATA_STANDARDS = _objectSpread(_objectSpread({}, POSTCODE), {}, {
  maxLength: 10,
  validationMessageKeys: _objectSpread(_objectSpread({}, POSTCODE.validationMessageKeys), {}, {
    maxLength: 'Sorry, the postcode entered is too long'
  })
});